import { graphql } from '../../../graphql/generated';

export const TAGS_QUERY = graphql(`
  query TagManagement_Tags {
    tags {
      id
      name
      color
    }
  }
`);

export const CREATE_TAG_MUTATION = graphql(`
  mutation CreateTag($input: TagInput!) {
    createTag(input: $input) {
      id
    }
  }
`);

export const UPDATE_TAG_MUTATION = graphql(`
  mutation UpdateTag($id: ID!, $input: TagInput!) {
    updateTag(id: $id, input: $input) {
      id
    }
  }
`);

export const DELETE_TAG_MUTATION = graphql(`
  mutation DeleteTag($id: ID!) {
    deleteTag(id: $id)
  }
`);
